<template>
  <div class="simulator-container">
    <!-- Header -->
    <header class="simulator-header">
      <div class="header-left">
        <div class="logo">
          <img src="@/assets/images/Logo.png" width="40" height="40" alt="Simulador" />
          <span class="title">Simulador Responsive</span>
        </div>
        <div class="status">
          <span class="status-badge active">Activo</span>
        </div>
      </div>

      <div class="header-right">
        <button @click="goBack" class="back-btn">
          <i class="bi bi-arrow-left"></i> Volver
        </button>
      </div>
    </header>

    <!-- Contenido Principal -->
    <main class="simulator-main">
      <!-- Controles -->
      <div class="controls-section">
        <h2><i class="bi bi-phone"></i> Simulador de Dispositivos</h2>

        <div class="device-controls">
          <div class="control-group">
            <label>Dispositivo:</label>
            <select v-model="selectedDevice" class="device-select">
              <option value="mobile">Mobile (375x667)</option>
              <option value="tablet">Tablet (768x1024)</option>
              <option value="desktop">Desktop (1200x800)</option>
            </select>
          </div>

          <button @click="refreshSimulator" class="refresh-btn">
            <i class="bi bi-arrow-clockwise"></i> Actualizar
          </button>
        </div>
      </div>

      <!-- Área del Simulador -->
      <div class="simulator-area">
        <div class="simulator-frame">
          <iframe
            :src="previewUrl"
            class="site-preview"
            :class="getDeviceStyle"
          ></iframe>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'ResponsiveSimulatorPage',
  data() {
    return {
      selectedDevice: 'mobile',
      previewUrl: window.location.origin
    }
  },
  computed: {
    getDeviceStyle() {
      const devices = {
        mobile: 'mobile-device',
        tablet: 'tablet-device',
        desktop: 'desktop-device'
      };
      return devices[this.selectedDevice] || 'mobile-device';
    }
  },
  methods: {
    refreshSimulator() {
      const iframe = document.querySelector('.site-preview');
      iframe.src = iframe.src;
    },

    goBack() {
      window.history.back();
    }
  },

  mounted() {
    console.log('🚀 Simulador Responsive montado');
  }
}
</script>

<style scoped>
/* ===== VARIABLES ===== */
:root {
  --color-background: #0F1420;
  --color-surface: #1A2235;
  --color-primary: #5C8DF6;
  --color-text-primary: #E8EDF5;
  --color-text-secondary: #8A9BB0;
  --color-success: #10B981;
  --border-radius: 12px;
  --border-radius-sm: 8px;
  --shadow-md: 0 4px 16px rgba(0, 0, 0, 0.4);
  --shadow-lg: 0 8px 32px rgba(0, 0, 0, 0.5);
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ===== BASE ===== */
.simulator-container {
  min-height: 100vh;
  background: var(--color-background);
  color: var(--color-text-primary);
  font-family: 'Segoe UI', system-ui, -apple-system, sans-serif;
}

/* ===== HEADER ===== */
.simulator-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  background: var(--color-surface);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.logo {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.title {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--color-text-primary);
  background: linear-gradient(135deg, var(--color-primary) 0%, #6366F1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.status-badge {
  padding: 0.5rem 1.25rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.status-badge.active {
  background: rgba(16, 185, 129, 0.15);
  color: var(--color-success);
  border: 1px solid rgba(16, 185, 129, 0.3);
}

.back-btn {
  background: rgba(255, 255, 255, 0.08);
  color: var(--color-text-primary);
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 0.75rem 1.5rem;
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: inherit;
}

.back-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  transform: translateY(-2px);
}

/* ===== MAIN CONTENT ===== */
.simulator-main {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.controls-section {
  background: var(--color-surface);
  padding: 1.5rem;
  border-radius: var(--border-radius);
  border: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 2rem;
}

.controls-section h2 {
  margin: 0 0 1.5rem 0;
  color: var(--color-text-primary);
  font-size: 1.25rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.device-controls {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.control-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.control-group label {
  font-weight: 600;
  color: var(--color-text-primary);
  font-size: 0.9rem;
}

.device-select {
  padding: 0.75rem 1rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--border-radius-sm);
  background: rgba(255, 255, 255, 0.08);
  color: var(--color-text-primary);
  font-size: 0.9rem;
  transition: var(--transition);
  font-family: inherit;
  cursor: pointer;
  min-width: 180px;
}

.device-select:focus {
  border-color: var(--color-primary);
  background: rgba(255, 255, 255, 0.12);
  outline: none;
  box-shadow: 0 0 0 2px rgba(92, 141, 246, 0.1);
}

.refresh-btn {
  background: var(--color-primary);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: var(--border-radius-sm);
  cursor: pointer;
  transition: var(--transition);
  font-size: 0.9rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-family: inherit;
}

.refresh-btn:hover {
  background: rgba(92, 141, 246, 0.9);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(92, 141, 246, 0.3);
}

/* ===== SIMULATOR AREA ===== */
.simulator-area {
  background: var(--color-surface);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--border-radius);
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 600px;
}

.simulator-frame {
  background: rgba(0, 0, 0, 0.2);
  border-radius: var(--border-radius-sm);
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

/* ===== DISPOSITIVOS ===== */
.site-preview {
  border-radius: 12px;
  box-shadow: var(--shadow-lg);
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: white;
  transition: all 0.3s ease;
}

/* Mobile */
.mobile-device {
  width: 375px;
  height: 667px;
  transform: none;
}

/* Tablet */
.tablet-device {
  width: 768px;
  height: 1024px;
  transform: none;
}

/* Desktop */
.desktop-device {
  width: 1200px;
  height: 800px;
  transform: none;
}

/* ===== RESPONSIVE ===== */
@media (max-width: 1400px) {
  .desktop-device {
    transform: scale(0.9);
  }
}

@media (max-width: 1300px) {
  .desktop-device {
    transform: scale(0.85);
  }
}

@media (max-width: 1200px) {
  .desktop-device {
    transform: scale(0.8);
  }

  .tablet-device {
    transform: scale(0.95);
  }
}

@media (max-width: 1100px) {
  .desktop-device {
    transform: scale(0.75);
  }

  .tablet-device {
    transform: scale(0.9);
  }
}

@media (max-width: 1000px) {
  .desktop-device {
    transform: scale(0.7);
  }

  .tablet-device {
    transform: scale(0.85);
  }

  .mobile-device {
    transform: scale(0.95);
  }
}

@media (max-width: 900px) {
  .tablet-device {
    transform: scale(0.8);
  }

  .mobile-device {
    transform: scale(0.9);
  }

  .device-controls {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }
}

@media (max-width: 800px) {
  .tablet-device {
    transform: scale(0.75);
  }

  .mobile-device {
    transform: scale(0.85);
  }

  .simulator-main {
    padding: 1rem;
  }

  .simulator-area {
    padding: 1rem;
  }
}

@media (max-width: 700px) {
  .tablet-device {
    transform: scale(0.7);
  }

  .mobile-device {
    transform: scale(0.8);
  }

  .simulator-header {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }
}

@media (max-width: 600px) {
  .tablet-device {
    transform: scale(0.65);
  }

  .mobile-device {
    transform: scale(0.75);
  }
}

@media (max-width: 500px) {
  .tablet-device {
    transform: scale(0.6);
  }

  .mobile-device {
    transform: scale(0.7);
  }
}

/* ===== SCROLLBAR ===== */
::-webkit-scrollbar {
  width: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}
</style>
